import { FC } from 'react'
import { Card } from '@cmsgov/ds-medicare-gov'
import { useTranslation } from 'react-i18next'
import classes from './PaymentDetailsCard.module.scss'
import { MySpinner } from 'components/MySpinner/MySpinner'
import { useFetchPaymentDetails } from 'queries/premiums'
import { useUserQuery } from 'queries/user'
import { PaymentTypeACH, PaymentTypeCREDITORDEBITMEDICAREGOV } from '@cms-max/medicare-api-sdk'

export interface PaymentDetailsCardProps {
  agencyTrackingId: string,
  appId: string,
  className?: string
}

export const PaymentDetailsCard: FC<PaymentDetailsCardProps> = ({ agencyTrackingId, appId, className }) => {
  const { t } = useTranslation('paymentDetailsCard')
  const userData = useUserQuery()
  const paymentDetails = useFetchPaymentDetails(agencyTrackingId, appId)
  const isLoading = userData.isLoading || paymentDetails.isLoading
  const userFullName = `${userData.data?.user?.firstName} ${userData.data?.user?.middleName} ${userData.data?.user?.lastName}`
  const currencyFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
  const formattedPaymentAmount = paymentDetails.data?.details?.paymentAmount ? currencyFormat.format(paymentDetails.data?.details?.paymentAmount) : ''
  const dateFormatOptions: Intl.DateTimeFormatOptions = {
    hour12: true,
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  }
  const formattedPaymentDate = new Date(paymentDetails.data?.details?.paymentDate || '').toLocaleString('en-US', dateFormatOptions).replace(',', '')
  let paymentMethod

  if (paymentDetails.data?.details?.paymentMethod === PaymentTypeACH.Ach) {
    paymentMethod = t('paymentMethods.ach')
  } else if (paymentDetails.data?.details?.paymentMethod === PaymentTypeCREDITORDEBITMEDICAREGOV.CreditOrDebitMedicareGov) {
    paymentMethod = t('paymentMethods.creditOrDebit')
  } else {
    paymentMethod = ''
  }

  return (
    <>
      <h2>{t('paymentDetailsHeader')}</h2>
        {isLoading && (
          <div>
            <MySpinner />
          </div>
        )}
        {!isLoading && (
          <>
            <Card className={`${className} ${classes.paymentDetailsCard} ds-u-padding--3 ds-u-word-break`}>
              <dl className='ds-u-margin--0'>
                <dt>{t('confNumberHeader')}</dt>
                <dd>{paymentDetails.data?.details?.agencyTrackingId}</dd>
                <dt>{t('nameHeader')}</dt>
                <dd>{userFullName}</dd>
                <dt>{t('paymentDateHeader')}</dt>
                <dd>{formattedPaymentDate}</dd>
                <dt>{t('paymentAmountHeader')}</dt>
                <dd>{formattedPaymentAmount}</dd>
                <dt>{t('paymentMethodHeader')}</dt>
                <dd>{paymentMethod}</dd>
              </dl>
            </Card>
          </>
        )}
    </>
  )
}
